import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=3f27f72d&scoped=true"
import script from "./departmentTree.vue?vue&type=script&lang=js"
export * from "./departmentTree.vue?vue&type=script&lang=js"
import style0 from "./departmentTree.vue?vue&type=style&index=0&id=3f27f72d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f27f72d",
  null
  
)

export default component.exports